import { createAction } from 'redux-act';

export const DOMAINDATA_SET_DATA = createAction('DOMAINDATA_SET_DATA');
export const DOMAINDATA_SET_UNDEVELOPED = createAction('DOMAINDATA_SET_UNDEVELOPED');

export const setDomainData = data => dispatch => {
  return dispatch(DOMAINDATA_SET_DATA({ data }));
};

export const setDomainUndeveloped = () => dispatch => {
  return dispatch(DOMAINDATA_SET_UNDEVELOPED());
};
